import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import { HomeCarousel } from "./HomeCarousel";
import PoseCard from "./PoseCard";
import StylesCard from "./StylesCards";
import { useState } from "react";
import { Typography } from "@material-ui/core";
const premiumBenefits = [
  " Choose from various art styles, from classic manga-inspired designs to modern and avant-garde illustrations, ensuring that your hentai artwork matches your personal preferences.Our AI Hentai Generator brings characters to life with realistic body proportions, intricate facial expressions, and attention to detail, delivering an immersive experience.",
];
const imageInfo = [
  

  {
    image: ['homePage/realStyle.jpg',"homePage/realStyle2.jpg"],

    title: 'Real',
  },{
    image: ['homePage/hyperRealStyle.jpg','homePage/hyperRealStyle2.jpg'],
    title: 'Hyper Real',
  },
  {
    image: ['homePage/animeStyle1.jpg',"homePage/animeStyle2.jpg"],
    title: 'Anime',
  },
 
 
  
  {
    image: ['homePage/hyperRealAnime1.jpg',"homePage/hyperRealAnime2.jpg"],
    title: 'Hyper Real Anime',
  },
  // Add more image and title objects as needed
];

const cardStyle = {
  width: '300px',
  margin: '20px',
  borderRadius: '10px',
  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
};


const titleStyle = {
  background: 'linear-gradient(to bottom, #f06, #9f6)',
  color: 'white',
  padding: '10px',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
};

const textStyle = {
  padding: '20px',
  color: '#333',
};


const styleInfo = [
  {
    title: 'Real Style',
    text:
      "Experience the breathtaking realism of 'Real Style' and unleash your artistic potential.",
  },
  {
    title: 'Hyper-Real Style',
    text:
      "Push the boundaries of art with 'Hyper-Real Style' and explore uncensored artistic freedom.",
  },
  {
    title: 'Anime Style',
    text:
      "Embrace the enchanting allure of 'Anime Style' and embark on an artistic adventure.",
  },
];





const useStyles = makeStyles((theme) => ({
  // Increase <Container> padding so it's
  // at least half of <Grid> spacing to
  // avoid horizontal scroll on mobile.
  // See https://material-ui.com/components/grid/#negative-margin
  container: {
    padding: `0 ${theme.spacing(3)}px`,
  },
  image: {
    margin: "0 auto",
    maxWidth: 570,
    display: "block",
    height: "auto",
    width: "100%",
  },
  
}));
function HeroSection2(props) {
  const classes = useStyles();

  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container  style={{ padding:"0px 0px"}}>
       
      <Box sx={{ flexDirection: { xs: 'column-reverse',lg: 'row' } }} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
       
        <Grid container xs={12} lg={6}  style={{margin:"0px",padding:"0px"}}>
              {imageInfo.map((info, index) => (
                <Grid
                  item
                  xs={6}
                  lg={6}
                  style={{
                    width: '250px',
                    height: 'auto',
                    display: 'flex',
                    justifyContent: index % 2 === 0 ? 'flex-end' : 'flex-start',
                    alignItems: 'center',
                  }}
                  key={index}
                >
                  <StylesCard
                    image={info.image[0]}
                    image2={info.image[1]}
                    
                    title={info.title}
                    bottom={index % 2 === 0 ? null : 20}
                 
                  />
                  
                </Grid>
              ))}
         
        </Grid>
        <Grid container xs={12} lg={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',
 }}>
  <Box>
 
    <Box
  id="right"
  sx={{
    display: { xs: "flex", sm: "flex", md: "flex" },justifyContent: "space-around",
    flexDirection: "column",
  }}
>
          <Box
            sx={{
              flexDirection: "column",
              gap: "6px", 
            }}
          > <Typography variant="h3"  style={{fontWeight:"500", fontFamily:" Chakra Petch, sans-serif",fontSize:"30px"}} >
Your mind is the only boundary to what you can generate.
</Typography>
            
            <Box>
 <Box  sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px"

                }}
              >
                {/* Premium Benefits List */}
                {premiumBenefits.map((benefit, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexDirection: "row",

                    }}
                    style={{  borderRadius:"0px 20px 0px 20px",
                   width:"auto",
                      }}

                  >
                  
                    <Typography
                      variant="body2"

                      sx={{
                        color: "white",
                        fontSize: "sm",
                        fontWeight: "medium",
                        lineHeight: "tight", 
                        
                      }}
                      style={{fontFamily:"Chakra Petch, sans-serif",fontSize:"18px",padding: "6px",
                    
                    }}
                    >
                      {benefit}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
       <Box style={{display:"flex", justifyContent:"flex-start",gap:"10px"}}>
       <Button  component={Link} to="/create" variant="contained" style={{background:"#6600FF",color:"white"}}>Try Now</Button>
<Button variant="outlined"  component={Link} to="/blogList">Learn More</Button>
       </Box>
         
          </Box>
          <Box
            sx={{
              display:{sm:"none",lg:"block"},
              position:"relative",
              textAlign: "center",
              marginBottom: "6px",
            }}
          >
            <img
              src="homePage/featureImage4.png"
              alt="Manga"
              style={{ width: "65%",minWidth:"300px", objectFit: "cover" }}
            />
          </Box>
         </Box>
  </Box>
</Grid>


       </Box>
      </Container>
    </Section>
  );
}

export default HeroSection2;
